// src/hooks/useEvents.js
import { useState, useEffect } from 'react';
import { fetchFilteredEvents } from '../services/dataService';

export const useEvents = (token, server, dateRange) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // Был ли хоть один ответ (удачный или нет): до него — скелетоны, после — старые числа при перезагрузке
  const [loaded, setLoaded] = useState(false);
  const [events, setEvents] = useState({});
  const [eventCounts, setEventCounts] = useState({
    loss_orders: 0,
    loss_money: 0,
    manipulations: 0,
    unusual_actions: 0,
  });

  useEffect(() => {
    if (!server || !dateRange.from || !dateRange.to) return;

    const fetchEvents = async () => {
      setLoading(true);
      try {
        const fetchedData = await fetchFilteredEvents(token, server, dateRange);
        // Ошибку прошлой загрузки сбрасываем только после успешного ответа
        setError(null);

        console.log('📦 fetchedData =', fetchedData);

        // ✅ Берём объект с группами
        const grouped = fetchedData?.filtered_events || {};

        // ✅ Подстраховка: если API вернул массив (старый формат)
        if (Array.isArray(grouped)) {
          console.warn('⚠️ API вернул массив, ожидается объект с группами');
          setEvents({ loss_orders: grouped });
          setEventCounts({ loss_orders: grouped.length });
          return;
        }

        // ✅ Подсчёт количества событий по группам
        const counts = {
          loss_orders: grouped.loss_orders?.length || 0,
          loss_money: grouped.loss_money?.length || 0,
          manipulations: grouped.manipulations?.length || 0,
          unusual_actions: grouped.unusual_actions?.length || 0,
        };

        setEvents(grouped);
        setEventCounts(counts);
        console.log('✅ События загружены:', grouped);
      } catch (error) {
        console.error('Ошибка при загрузке событий:', error);
        // Не показываем данные прошлого запроса под видом текущих; null — «нет данных»
        setEvents({});
        setEventCounts(null);
        setError(error);
      } finally {
        setLoading(false);
        setLoaded(true);
        setLoaded(true);
      }
    };

    fetchEvents();
  }, [token, server, dateRange]);

  return { loading, loaded, events, eventCounts, error };
};
